import React from 'react';

import PlaceholderTab from '~/components/Offers/Detail/OfferBuilder/shared/PlaceholderTab';

import { FORECASTING_FIELDS } from './fields';

export default function ForecastingTab() {
  return <PlaceholderTab configuredFieldCount={FORECASTING_FIELDS.length} title="Forecasting" />;
}
